import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-chat-bot',
  templateUrl: './demo-chat-bot.component.html',
  styleUrls: ['./demo-chat-bot.component.css']
})
export class DemoChatBotComponent implements OnInit {


  public scriptContent = `
  var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
  (function(){
  var s1=document.createElement("script"),
  s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='https://embed.tawk.to/63a3004adaff0e1306ddb6da/1gkqbi95b';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
  })();
  `;

  constructor() { }

  ngOnInit(): void {
    this.loadChatBot();
  }

  loadChatBot(){
    var contentEl = document.getElementsByTagName("BODY")[0];
    let script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'emps-custom-tawk-chat-bot'
  script.text = this.scriptContent;
  contentEl.appendChild(script);

    // var script = document.createElement("script");
    // script.innerHTML = 
    // script.onload = function() {
    //   console.log("Script loaded and ready");
    // };
    // script.src = "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image";
    // document.getElementsByTagName('head')[0].appendChild(script);

    // s = 
      
    // ;
    // console.dir(document.getElementById('custom-chat-bot'))
  }

  ngOnDestroy(){
    let contentEl:any = document.getElementById('emps-custom-tawk-chat-bot');
    contentEl.text = '';
    
  }

  

}
